import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    var chartwork = new Object();
    $(this.element).on("mouseover mouseleave", "td", function (e) {
      var n = $(this).index() + 1;
      if (e.type == "mouseover") {
        if ($(this).index() != 0) {
          clearTimeout(chartwork["to" + n]);
          $("#pricing_tiers tr td:nth-child(" + n + ")").addClass("hover");
        }
      } else {
        if ($(this).index() != 0) {
          chartwork["to" + n] = setTimeout(function () {
            $("#pricing_tiers tr td:nth-child(" + n + ")").removeClass("hover");
          }, 50);
        }
      }
    });
  }
  disconnect() {
    $(this.element).off();
  }
}
